<template>
  <AnimatedButton
    v-on:click="$emit('click')"
    v-on:animated-click="$emit('animated-click')"
    v-bind:style="currentQuestion.number === 'three' || currentQuestion.number === 'four' ? 
                         {'backgroundColor': 'rgb('+ selectedColor.red + ',' + selectedColor.green + ',' + selectedColor.blue + ')'}: null"
    v-bind:class="[{'white' : selectedColor.type === 'dark'}, {'visible': activeItem !== null}]"
    text="Next"
  ></AnimatedButton>
</template>

<script>
import AnimatedButton from "./AnimatedButton.vue";

export default {
  name: "NextButton",
  components: { AnimatedButton },
  props:  ['activeItem', 'currentQuestion', 'selectedColor']
};
</script>